import React from 'react'

function Footer() {
    return (
        <footer id="footer">
            <div className="container">
                <div className="d-flex align-items-center justify-content-center">
                    <div className="col-lg-122 text-lg-left text-center">
                        <div className="copyright">
                            © Copyright <strong> Abdul Saboor</strong>.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;